import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { designSystem } from '@/styles/styles';

const SVGComponent = props => (
    <Svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <Path
            d="M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0ZM5.33301 9.125C4.84991 9.12518 4.45801 9.51686 4.45801 10C4.45801 10.4831 4.84991 10.8748 5.33301 10.875H14.666C15.1493 10.875 15.541 10.4832 15.541 10C15.541 9.51675 15.1493 9.125 14.666 9.125H5.33301Z"
            fill={props.fill || designSystem.colors.neutral300}
        />
    </Svg>
);

export default SVGComponent;
